// extracted by mini-css-extract-plugin
export var orderDetails = "_kb-2";
export var orderImage = "_kb-1";
export var orderMeta = "_kb-3";
export var orderSummary = "_kb-0";
export var rightArrow = "_kb-4";